export default __webpack_public_path__ + "77a6270f0632a0c03abf29e8afab93ae.svg";